module.exports = __webpack_public_path__ + "static/media/game(5).09945693.PNG";